import { toggleAttr } from './utils.js';

// открытие/закртие выпадающих списков
export function showDropDownList() {
  if (this) this.disabled = true;

  const parentElement = this.parentElement;
  const dropDownContent = parentElement.querySelector('[data-role=drop-down]');

  parentElement.classList.toggle('js_dke_active');
  toggleDropDown(dropDownContent, () => {
    if (this) this.disabled = false;
  });
  updateAriaExpanded(parentElement);
}

export function closeAllDropDown(btnsDropDown, excludedIndex) {
  btnsDropDown.forEach((element, index) => {
    if (index !== excludedIndex) {
      element.disabled = false;
      const parentElement = element.parentElement;
      parentElement.classList.remove('js_dke_active');
      const dropDownContent = parentElement.querySelector('[data-role=drop-down]');
    
      if (dropDownContent.style.height) {
        close(dropDownContent);
      }
    }
  });
}

// открытие/закрытие выпадающего списка
function toggleDropDown(element, updateDisabled) {
  if (element) {
    if (element.style.height === '') {
      open(element, updateDisabled);
    }
    else {
      close(element, updateDisabled);
    }
  }
}

// открытие выпадающего списка
function open(element, updateDisabled) {
  const endHeight = window.getComputedStyle(element).height;
  element.style.height = '0px';
  requestAnimationFrame(() => {
    element.style.height = endHeight;
  });
  element.addEventListener(
    'transitionend',
    () => {
      element.style.height = 'auto';
      updateDisabled?.();
    },
    { once: true }
  );
}

// закрытие выпадающего списка
function close(element, updateDisabled) {
  const endHeight = window.getComputedStyle(element).height;
  element.style.height = endHeight;
  requestAnimationFrame(() => {
    element.style.height = '0px';
  });
  element.addEventListener(
    'transitionend',
    () => {
      element.removeAttribute('style');
      updateDisabled?.();
    },
    { once: true }
  );
}

// поиск элемента с атрибутом aria-expanded и изменение его значения
function updateAriaExpanded(parentElement) {
  if (parentElement.hasAttribute('aria-expanded')) {
    toggleAttr(parentElement, 'aria-expanded');
  } else {
    const elementAriaAttr = parentElement.querySelector('[aria-expanded]');
    if (elementAriaAttr) {
      toggleAttr(elementAriaAttr, 'aria-expanded');
    }
  }
}
